import __ from "web/Layout/Translations";

import formatNumber from "web/utils/data/parser/number/formatNumber";

import { RentableGroupCalculatorCopy } from "../const/rentableGroupCalculatorCopy";
import classes from "./rentableGroupCalculatorTotalIncomeMessage.scss";

interface IRentableGroupCalculatorTotalIncomeMessageProps {
  totalIncome: number;
  calculatorCopy: RentableGroupCalculatorCopy;
}

const RentableGroupCalculatorTotalIncomeMessage = ({
  totalIncome,
  calculatorCopy,
}: IRentableGroupCalculatorTotalIncomeMessageProps) => {
  const { totalIncomeTooHigh } = calculatorCopy || {};

  return (
    <div className={classes.root}>
      <p>
        {__(totalIncomeTooHigh)} {formatNumber(totalIncome)} {__("zł")}.
      </p>
    </div>
  );
};

export default RentableGroupCalculatorTotalIncomeMessage;
